/**
 * Compute the row background color for a client based on their 4 QoL toggles.
 *
 * Mapping:
 *   - good = +1, neutral = 0, bad = -1
 *   - score range: [-4, +4]
 *   - -4 → bright red, +4 → bright green, 0 → soft yellow, mixes interpolate via HSL hue
 *
 * Special cases:
 *   - Onboarding not yet completed → light blue (signals "needs follow-up")
 *   - Any of the four toggles unset → null (render default white)
 */
/** good = +1, neutral = 0, bad = -1 */
function qolValueToScore(v) {
  if (v === "good") return 1;
  if (v === "bad") return -1;
  return 0;
}

export function rowColorForUser(user) {
  if (!user?.onboarding_completed) return "#D6E8F5"; // light blue
  const s = user?.qol_state;
  if (!s) return null;
  const vals = [s.feel, s.past, s.future, s.inner_self_talk];
  if (vals.some((v) => v == null)) return null;
  const score = vals.reduce((acc, v) => acc + qolValueToScore(v), 0);
  // Normalize: -4 → 0 (red), 0 → 0.5 (yellow), +4 → 1 (green)
  const t = (score + 4) / 8;
  // Hue 0=red, 120=green. Tint: lightness high for readability, saturation strong for "bright"
  const hue = Math.round(t * 120);
  return `hsl(${hue}, 70%, 78%)`;
}
